import { util } from '../util/axiosConf';
const  pre = 'api/licenselmp';
export default {  
  submitApplication(params) {
    return util.post(`${pre}/sds-license/submit-application`, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
  },
};
